module.exports = __webpack_public_path__ + "static/videos/etch_003.b991a10.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/etching/etch_003.mp4
// module id = 465
// module chunks = 1